import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import toast from "react-hot-toast";
import '../../Assets/CSS/EmployeeOnboard.css'
import LightText, { lastOne, LightDark, Lightight } from "../../Assets/CSS/Text";
import { Continuebtn, Ctnbtn, Newbtn } from "../../Assets/CSS/Button";
import axios from "axios";

const Documents = ({ empData, setActiveTab }) => {
    console.log("document", empData);
    const [docsState, setDocsState] = useState();
    const [loading, setLoading] = useState(false);
    const [approvedIndex, setApprovedIndex] = useState(null);

    const email = empData?.personalEmail

    // fetching document
    const fetchDocument = async () => {
        const token = localStorage.getItem('token');
        if (!token) return toast.error("Token is missing!");

        try {
            setLoading(true);
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/documents?email=${email}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "*/*",
                        "Content-Type": "application/json",
                    },
                }
            );

            // Map response to frontend structure
            const formatted = response.data.map((doc) => ({
                id: doc.documentId,
                title: doc.fileName,
                isMandatory: doc.mandatory,
                key: doc.fileName.toLowerCase().replace(/\s+/g, ""), // e.g., "Aadhar card" -> "aadharcard"
                status: doc.fileStatus,
                file: doc.fileUrl || null,
                size: doc.fileSize || "",
                uploadedFile: null,
                statusColor: "#FFE8CC",
            }));
            console.log(formatted)
            setDocsState(formatted);
        }
        // catch (error) {
        //     console.error("Error fetching documents:", error);
        //     toast.error(error.response?.data?.message || "Failed to fetch documents");
        // }
        catch (error) {
            console.error("Error fetching documents:", error);

            const errorMessage =
                error?.response?.data?.message ||
                // error?.response?.data?.error ||
                "No document available to view";

            toast.error(errorMessage);
        }

        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchDocument();
    }, []);
    const handleViewDocument = async (documentId) => {
        const token = localStorage.getItem("token");
        if (!token) return toast.error("Token is missing!");

        try {
            setLoading(true);

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/documents/${documentId}/download-url?expiresIn=600`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "*/*",
                    },
                }
            );

            const fileUrl = response.data?.url || response.data; // depends on backend format

            if (!fileUrl) {
                toast.error("Download URL not received");
                return;
            }

            window.open(fileUrl, "_blank"); // OPEN FILE IN NEW TAB ✔
        }
        catch (error) {
            console.error(error);
            toast.error("No document available to view");
        }
        finally {
            setLoading(false);
        }
    };

    // updating ststus

    const handleDocumentStatus = async (documentId, status) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");

            const response = await axios.patch(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/documents/${documentId}/status?status=${status}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "*/*",
                    }
                }
            );

            console.log("API Response:", response);


            if (response.status === 200) {
                setDocsState((prev) =>
                    prev.map((item) =>
                        item.id === documentId ? { ...item, status: status } : item
                    )
                );

                // toast.success("Document updated!");
                // ✅ Show toast based on status
                if (status === "APPROVED") {
                    toast.success("Document has been approved successfully");
                } else if (status === "REJECTED") {
                    toast.error("Document has been rejected successfully");
                }
            }


        } catch (error) {
            toast.error(error.response?.data?.message || "Error updating status");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const anyRejected = docsState?.some((d) => d.status === "REJECTED");

    const handleResendLink = async (email) => {
        try {
            setLoading(true)
            const token = localStorage.getItem('token');
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/documents/onboarding-link/resend?email=${email}`,
                {}, // empty body
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "*/*",
                    },
                }
            );
            console.log(response.data);
            if (response.status === 200) {
                toast.success("Link resent");
            }

        }

        catch (error) {
            toast.error(error.response?.data?.message || "Error updating status");
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }




    const allApproved =
        docsState?.length > 0 &&
        docsState.every(doc => doc.status === "APPROVED");



    return (
        <div className="col-11">
            <p style={Lightight}>Please check and verify the documents submitted by candidate.</p>

            {docsState?.map((doc, index) => (

                <div
                    key={index}
                    className="card mb-3 p-3 d-flex flex-row align-items-center justify-content-between doc-row"
                    style={{
                        backgroundColor: "#FFFFFF",
                        boxShadow: "none",
                        border: "1px solid #DBDBDB",
                        height: "85px",
                        width: "100%",
                    }}
                >
                    {/* LEFT SIDE */}
                    <div className="d-flex align-items-center gap-3">

                        {/* Document Icon */}
                        <div
                            className="rounded-circle d-flex justify-content-center align-items-center"
                            style={{
                                width: "55px",
                                height: "55px",
                                backgroundColor: "#EFEFEF",
                                border: "1px solid #F0F0F0",
                            }}
                        >
                            <Icon icon="mi:document" style={{ color: "#C1C1C1", fontSize: "24px" }} />
                        </div>

                        {/* Title + File Types */}
                        <div>
                            <h6 style={{ ...LightDark, margin: 0 }}>
                                {doc.title}
                                {doc.isMandatory && <span style={{
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    color: '#E00000'
                                }}>*</span>}
                            </h6>
                            {/* <h6 style={{ margin: 0 }}>{doc.title}<span className="text-danger">*</span></h6> */}
                            <p style={{ margin: 0, fontSize: "12px", color: "#6f6f6f" }}>
                                PDF, PNG, JPG (MAX 5mb)
                            </p>
                            {/* ✅ ADD HERE */}
                            {doc.status === "NOT_UPLOADED" && (
                                <p style={{ color: "orange", fontSize: "11px", margin: 0 }}>
                                    Candidate has not uploaded this document yet
                                </p>
                            )}
                        </div>
                    </div>

                    {/* RIGHT SIDE BUTTONS */}
                    <div className="d-flex align-items-center gap-3">

                        {/* VIEW BUTTON */}
                        <button className="doc-actions"
                            style={{
                                color: "#00AFEF",
                                border: "1px solid #00AFEF",
                                padding: "6px 16px",
                                borderRadius: "8px",
                                fontSize: "14px",
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                opacity: doc.file ? 1 : 0.5,     // grey look if not uploaded
                                cursor: doc.file ? "pointer" : "not-allowed",
                            }}
                            disabled={!doc.file}
                            onClick={() => {
                                if (!doc.file) {
                                    toast.error("Document not uploaded yet");
                                    return;
                                }
                                handleViewDocument(doc.id);
                            }}

                        >
                            <Icon
                                icon=
                                "hugeicons:view"
                                className="fs-6"

                            />

                            View
                        </button>

                        {/* APPROVE BUTTON */}

                        <button
                            className="doc-actions"
                            disabled={!doc.file}
                            onClick={() => {
                                if (!doc.file) {
                                    toast.error("Cannot approve. Document not uploaded.");
                                    return;
                                }
                                handleDocumentStatus(doc.id, "APPROVED", index);
                            }}
                            // onClick={() => handleDocumentStatus(doc.id, "APPROVED", index)}

                            style={{
                                color: doc.status === "APPROVED"
                                    ? "#22C55E"
                                    : doc.status === "REJECTED"
                                        ? "#FF8383"
                                        : "#22C55E",
                                border: doc.status === "APPROVED" || doc.status === "REJECTED"
                                    ? "none"
                                    : "1px solid #22C55E",
                                padding: "6px 16px",
                                borderRadius: "8px",
                                fontSize: "14px",
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                opacity: doc.file ? 1 : 0.5,     // grey look if not uploaded
                                cursor: doc.file ? "pointer" : "not-allowed",
                            }}

                        >
                            <Icon
                                // icon={
                                //     doc.status === "APPROVED"
                                //         ? "material-symbols:done-all-rounded"      // AFTER CLICK
                                //         : "material-symbols:done-rounded"          // BEFORE CLICK
                                // }
                                // style={{
                                //     color: doc.status === "APPROVED" ? "#22C55E" : "#22C55E",
                                //     fontSize: "20px",
                                // }}
                                icon={
                                    doc.status === "APPROVED"
                                        ? "material-symbols:done-all-rounded"
                                        : doc.status === "REJECTED"
                                            ? "iconoir:cancel"
                                            : "material-symbols:done-rounded"
                                }
                                style={{
                                    color: doc.status === "REJECTED" ? "#FF8383" : "#22C55E",
                                    fontSize: "20px",
                                }}
                            />
                            {/* {doc.status === "APPROVED" ? "Approved" : "Approve"} */}

                            {doc.status === "APPROVED"
                                ? "Approved"
                                : doc.status === "REJECTED"
                                    ? "Rejected"
                                    : "Approve"}
                        </button>


                        {/* REJECT BUTTON */}
                        {doc.status !== "APPROVED" && doc.status !== "REJECTED" ? (
                            <button className="doc-actions"
                                onClick={() => handleDocumentStatus(doc.id, "REJECTED")}
                                style={{
                                    backgroundColor: "transparent",
                                    color: "#E00000",
                                    border: "none",
                                    fontSize: "14px",
                                }}
                            >
                                Reject
                            </button>

                        ) : (
                            // EMPTY SPACE (same width as Reject button)
                            <div style={{ width: "60px" }}></div>
                        )}

                    </div>

                </div>
            ))
            }

            {
                !allApproved && (
                    <p style={{ color: "#E00000", fontSize: "14px" }}>
                        Please approve all mandatory documents to continue.
                    </p>
                )
            }

            {/* BOTTOM BUTTON */}
            {/* <button
                className="mt-5  mb-5 continue-btn"
                // style={Ctnbtn}
                style={{
                    ...Ctnbtn,
                    opacity: allApproved ? 1 : 0.5,
                    cursor: allApproved ? "pointer" : "not-allowed",
                }}
                disabled={!allApproved}
                onClick={() => {
                    if (!allApproved) return;
                    setActiveTab("salstr");
                }}

            // onClick={() => setActiveTab("salstr")}

            >
                Continue
            </button> */}

            <button
                className="mt-5 mb-5 "
                style={{
                    ...Ctnbtn,
                    opacity: allApproved ? 1 : 0.4,
                    cursor: allApproved ? "pointer" : "not-allowed",
                    pointerEvents: allApproved ? "auto" : "none", // 🔥 hard block
                }}
                disabled={!allApproved}
                onClick={() => {
                    if (!allApproved) return;   // 🔥 double safety
                    setActiveTab("salstr");
                }}
            >
                Continue
            </button>




            {
                anyRejected && (
                    <div
                        className="p-3 mb-4"
                        style={{
                            backgroundColor: "#F9F9F9",
                            borderRadius: "8px"
                        }}
                    >
                        <div className="d-flex justify-content-between align-items-start">

                            {/* LEFT TEXT SECTION */}
                            <div>
                                <h6 className="mb-1" style={lastOne}>
                                    Some documents submitted by the applicant have been rejected.
                                </h6>
                                <p className="mb-0" style={LightText}>
                                    If needed, you can request the candidate to re-upload the required documents.
                                </p>
                            </div>

                            {/* RIGHT BUTTON */}
                            <button className="" style={Newbtn}
                                onClick={() => handleResendLink(email)}
                                disabled={loading}
                            >
                                {loading && (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                )}
                                {loading ? "Please wait..." : "Re-Request Document"}

                            </button>
                        </div>
                    </div>
                )
            }


        </div >
    );


};

export default Documents;
